import { MouseEvent } from 'react';

import { DotsIcon, DotsVerticalIcon } from '@braskai/icons';
import { IconButton, Menu, MenuProps } from '@braskai/ui-kit';

import { SIconMenu } from './styled';

export const DOTS_MENU_MODE = {
  horizontal: 'horizontal',
  vertical: 'vertical',
} as const;

export type DotsMenuProps = {
  buttonTestId?: string;
  disablePortal?: boolean;
  size?: number;
  type?: keyof typeof DOTS_MENU_MODE;
} & Omit<MenuProps, 'children' | 'size'>;

export const DotsMenu = ({
  buttonTestId,
  disablePortal,
  size = 20,
  type = DOTS_MENU_MODE.horizontal,
  ...props
}: DotsMenuProps) => {
  const isDisablePortal = type === DOTS_MENU_MODE.horizontal || disablePortal;

  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
  };

  return (
    <Menu
      disablePortal={isDisablePortal}
      zIndexPopover={isDisablePortal ? 9999 : undefined}
      disableMobileView
      {...props}
    >
      {type === DOTS_MENU_MODE.vertical ? (
        <IconButton
          sx={(theme) => ({
            color: theme.palette.grey[700],
            zIndex: theme.zIndex.basic,
          })}
          data-testid={buttonTestId}
          disableBackground
          disableFixSizeIcon
          onClick={handleClick}
        >
          <DotsVerticalIcon height={size} width={size} />
        </IconButton>
      ) : (
        <SIconMenu data-testid={buttonTestId} disableBackground disableFixSizeIcon onClick={handleClick}>
          <DotsIcon height={size} width={size} />
        </SIconMenu>
      )}
    </Menu>
  );
};
